import runColors from "../createColors/runColors.js";
/**
 *
 * @param {lightTheme} lightTheme - lightTheme object
 * @param {darkTheme} darkTheme - darkTheme object
 * @param {string} paletteColorName - name of the palette color
 * @param {string} colorValue - value of the color
 * @returns {{light:Theme, dark:Theme}} object with light theme and dark theme
 * @description create object with light theme and dark theme for mui createTheme
 * it will setup the mode and colors automatically.
 * provide object with palette name and color.
 */
const muiAddString = (lightTheme, darkTheme, paletteColorName, colorValue) => {
  let colors = runColors(colorValue);
  lightTheme.palette[paletteColorName] = { main: colors.light };
  darkTheme.palette[paletteColorName] = { main: colors.dark };
  return true;
};

export default muiAddString;
